<ng-container *transloco="let convert;">
  <div class="wrapper">
    <div class="container">
      <div class="layout">
        <app-inventory-management-header></app-inventory-management-header>
        @defer {
          <div class="banner-wrapper">
            @if (multiOfferActionSuccess) {
              <app-common-banner (close)="closeSuccessBanner()"
                                 [bannerConfig]="multiOfferActionSuccess"></app-common-banner>
            }
            @for (errorBanner of multiOfferActionErrors; track errorBanner; let index = $index) {
              <app-common-banner
                (close)="closeErrorBanner(index)" [bannerConfig]="errorBanner"></app-common-banner>
            }
          </div>
        }
        <app-active-vehicles-count [count]="InventorySearchResponseCount" [resultText]="inventoryManagementLayoutTranslations$().vehicleResultText" role="alert"></app-active-vehicles-count>

        <div class="layout__body">
          <div class="layout__sidebar">
            <app-search-filter [isMobile]=isMobile></app-search-filter>
          </div>

          <div class="layout__main-area" [style.overflow]="isMobile ? 'visible' : 'auto'">
            <app-utility-bar
              [isExporting]="isExporting"
              [isSellReportingFeatureEnabled]="isSellReportingFeatureEnabled"
              [inServiceVehiclesEnabled]="isInServiceVehiclesEnabled"
              [singleListSelected]="isSingleOfferListSelected"
              [disableSelectAll]="disableSelectAll"
              [isFilterByInServiceVehicles]="filterByIsv$()"
              (exported)="onExport()"
              (exportedAll)="onExportAll()"
              (mobileFilter)="mobileFilter = $event"
              #libBar
            ></app-utility-bar>

            @if (isSingleOfferListSelected) {
              <div class="mt-3">
                {{convert('sellModule.manageInventory.utilityBar.textMultiPurchaseNote')}}
              </div>
            }

           @if (isListViewToggleVisible) {
              <ng-content *ngTemplateOutlet="cardListViewToggleButtons"></ng-content>
           }

              <div
                id="layout-body"
                aria-hidden="false"
                class="mt-3"
              >
                @if (!searchError) {
                  @if (isMissingVinsOrStockNumbers) {
                      <app-multi-vin-error
                        [vins$]="missingVins"
                        [stockNumbers$]="missingStockNumbers"
                      ></app-multi-vin-error>
                  }
                  @if (isLoading) {
                    <app-inventory-skeleton></app-inventory-skeleton>
                    <app-inventory-skeleton></app-inventory-skeleton>
                    <app-inventory-skeleton></app-inventory-skeleton>
                  }
                  @if (!isLoading) {
                    @if (showSearchTip) {
                      <p>{{showSearchTip}}</p>
                    }
                  }
                  @if (inventoryManagementVehicles$()?.length === 0 && !isLoading) {
                    <app-error-message
                      title="{{convert('sellModule.manageInventory.layout.textErrorTitle')}}"
                      subtitle="{{convert('sellModule.manageInventory.layout.textErrorSubTitle')}}"
                    ></app-error-message>
                  }
                  @if (!isLoading && inventoryManagementVehicles$()) {
                    @if (inventoryManagementVehicles$().length > 0 && isListView$()) {
                      @if (!isMobile) {
                        <div class="list-view-table-wrapper">
                          <table aria-label="Manage Inventory List View Table">
                            @if (!isVehicleFilterTypeISV) {
                              <thead>
                              <tr>
                                <th id="Vehicle Header" class="ps-4 sticky-col first-col list-view-headers">{{convert('sellModule.manageInventory.listView.textVehicle')}}</th>
                                <th id="Actions Header" class="sticky-col second-col list-view-headers" aria-hidden="true"></th>
                                <th id="Shadow Header" class="shadow-col list-view-headers" aria-hidden="true"></th>
                                <th id="Offers Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textOffers') | uppercase }}</th>
                                <th id="Questions Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textQuestions') | uppercase}}</th>
                                <th id="Status Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textStatus')}}</th>
                                <th id="Highest Offer Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textHighestOffer')}}</th>
                                @if (showHistoricalHighColumn) {
                                  <th id="Historical High Header" class="col list-view-headers"
                                    data-test-id="inventory-management-list-view-historical-high-header">
                                    {{inventoryManagementLayoutTranslations$().historicalHigh | uppercase}}
                                  </th>
                                }
                                <th id="Buy Now Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textBuyNow')}}</th>
                                <th id="Opening Price Header" class="col list-view-headers"> {{convert('sellModule.manageInventory.listView.textOpeningPrice')}}</th>
                                @if (showSaleFeeAndSalePriceColumn) {
                                  <th id="Sale Fee Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textSaleFee')}}</th>
                                }
                                @if (showSaleFeeAndSalePriceColumn) {
                                  <th id="Sale Price Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textSalePrice')}}</th>
                                }
                                @if (showTotalPriceColumn) {
                                  <th id="Total Price Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textTotalPrice')}}</th>
                                }
                                <th id="Shadow Header" class="shadow-col-end list-view-headers" aria-hidden="true"></th>
                              </tr>
                              </thead>
                            } @else {
                              <thead>
                              <tr>
                                <th id="Vehicle Header" class="ps-4 sticky-col first-col list-view-headers">{{convert('sellModule.manageInventory.listView.textVehicle')}}</th>
                                <th id="Actions Header" class="sticky-col second-col list-view-headers" aria-hidden="true"></th>
                                <th id="Shadow Header" class="shadow-col list-view-headers" aria-hidden="true"></th>
                                <th id="Status Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textReserveStatus')}}</th>
                                <th id="Grounded Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textGrounded')}}</th>
                                <th id="Location Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textLocation')}}</th>
                                <th id="List Price Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textListPrice')}}</th>
                                <th id="Miles Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textMiles')}}</th>
                                <th id="Shadow Header" class="shadow-col-end list-view-headers" aria-hidden="true"></th>
                              </tr>
                              </thead>
                            }

                            <tbody>
                              @for (result of inventoryManagementVehicles$(); track result.auctionItemUuid + '_' + $index; let i = $index) {
                                <tr app-list-view-inventory-item
                                    class="list-view-inventory-item"
                                    [singleListSelected$]="isSingleOfferListSelected"
                                    [inputAuctionItemSell$]="result"
                                    [hadMultiOfferActionSuccess$]="hadMultiOfferActionSuccess(result)"
                                    [userProfile$]="userProfile$()"
                                    data-track-region="Card"
                                    [attr.data-track-result-number]="i + 1"
                                    [attr.data-track-scroll-number]="dataTrackScrollNumber(i + 1)"
                                    [index$]="i"
                                    [searchStatusFilter$]="inventoryCurrentStatus$()"
                                    [isMobileLayout$]="isMobile"
                                    [isDesktop$]="isMobile"
                                    [tenantName$]="configuration$().tenantName"
                                    [tenantUuid$]="configuration$().tenantUuid"
                                    [isServiceFeeVisible$]="isServiceFeeVisible"
                                    [inputVehicleSelectionsEnabled$]="isSellUpdateInventoryFeatureEnabled || areSellCheckboxesEnabled"
                                    [currentPage$]="inventorySearchResponse$().page"
                                    [offerLists$]="result.offerLists"
                                    [isFilterByInServiceVehicles$]="filterByIsv$()"
                                    (modalEvent)="createBanners($event)"
                                ></tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      @if (isMobile) {
                        @for (result of inventoryManagementVehicles$(); track result.auctionItemUuid + '_' + $index; let i = $index) {
                          <div app-list-view-inventory-item
                               class="list-view-inventory-item"
                               [singleListSelected$]="isSingleOfferListSelected"
                               [inputAuctionItemSell$]="result"
                               [hadMultiOfferActionSuccess$]="hadMultiOfferActionSuccess(result)"
                               [userProfile$]="userProfile$()"
                               data-track-region="Card"
                               [attr.data-track-result-number]="i + 1"
                               [attr.data-track-scroll-number]="dataTrackScrollNumber(i + 1)"
                               [index$]="i"
                               [searchStatusFilter$]="inventoryCurrentStatus$()"
                               [isMobileLayout$]="isMobile"
                               [isDesktop$]="!isMobile"
                               [tenantName$]="configuration$().tenantName"
                               [tenantUuid$]="configuration$().tenantUuid"
                               [isServiceFeeVisible$]="isServiceFeeVisible"
                               [inputVehicleSelectionsEnabled$]="isSellUpdateInventoryFeatureEnabled || areSellCheckboxesEnabled"
                               [currentPage$]="inventorySearchResponse$().page"
                               [offerLists$]="result.offerLists"
                               [isFilterByInServiceVehicles$]="filterByIsv$()"
                               (modalEvent)="createBanners($event)"
                          ></div>
                        }
                      }
                    }
                    @if (!isListView$()) {
                      @for (result of inventoryManagementVehicles$(); track result.vehicleUuid; let i = $index) {
                        <sw-vehicle-container-hook [vehicleData]="result" class="stockwave-vehicle-row">
                          <app-vehicle-card
                            [inputAuctionItemSell$]="result"
                            [userProfile$]="userProfile$()"
                            data-track-region="Card"
                            [attr.data-track-result-number]="i + 1"
                            [attr.data-track-scroll-number]="dataTrackScrollNumber(i + 1)"
                            [index$]="i"
                            [searchStatusFilter$]="inventoryCurrentStatus$()"
                            [isMobileLayout$]="isMobile"
                            [isDesktop$]="!isMobile"
                            [singleListSelected$]="isSingleOfferListSelected"
                            [tenantName$]="configuration$()?.tenantName"
                            [tenantUuid$]="configuration$()?.tenantUuid"
                            [isServiceFeeVisible$]="isServiceFeeVisible"
                            [inputVehicleSelectionsEnabled$]="isSellUpdateInventoryFeatureEnabled || areSellCheckboxesEnabled"
                            [sellerCommentsEnabled$]="sellerCommentsEnabled"
                            [currentPage$]="inventorySearchResponse$().page"
                            [offerLists$]="result.offerLists"
                            [isFilterByInServiceVehicles$]="filterByIsv$()"
                            [isDirty$]="hadMultiOfferActionSuccess(result)"
                          ></app-vehicle-card>
                        </sw-vehicle-container-hook>
                      }
                    }
                  }
                } @else {
                  <app-error-message title="{{ this.inventoryManagementLayoutTranslations$().labelErrorTitle }}" subtitle="{{ this.inventoryManagementLayoutTranslations$().labelErrorSubTitle }}">
                  </app-error-message>
                }
              </div>
          </div>
        </div>
        @if (!searchError && pagination$()?.totalItems && pagination$().totalItems > 0) {
          <app-pagination
            [currentPage]="pagination$().page + 1"
            [totalCount]="pagination$().totalItems"
            [perPage]="pagination$().itemsPerPage"
            [maxPages]="7"
            [hidePerPage]="false"
            (pageChanged)="handleChangePage($event)"
            (perPageChanged)="handleChangePerPage($event)"
            [pagination]="inventoryManagementLayoutTranslations$().paginationTranslation"
          ></app-pagination>
        }
      </div>
    </div>

    <app-action-submitting-modal [actionText]="exportActionText"></app-action-submitting-modal>
    <app-action-submitted-modal
      [actionText]="exportActionSuccessText"
      [auctionSubmittedTransl]="this.inventoryManagementLayoutTranslations$()?.auctionSubmitted"
      (focusOnElement)="focusOnElement()">
    </app-action-submitted-modal>
    <app-error-modal></app-error-modal>
  </div>

 <ng-template #cardListViewToggleButtons>
   @if (isListViewFeatureEnabled) {
     <span class="view-toggle-buttons">
     <!--Card View Button Icon -->
       <button
         data-track-elem="icon"
         data-track-name="card-view"
         class="btn view-btn"
         (click)="updateListViewToggle(false)"
         [disabled]="!isListView$()"
       >
         @if (isListView$()) {
           <img
             src="../../../ui/assets/assets-{{ configuration$()?.tenantName }}/{{ configuration$()?.tenantName }}-card-view.svg"
             alt="card view icon"
           />
         }

         @if (!isListView$()) {
           <img
             src="assets/icons/card-view-active.svg"
             alt="card view icon"
            />
         }
         <span>{{ convert('common.cardView') }}</span>
       </button>

    <!--List View Button Icon -->
       <button
         data-track-elem="icon"
         data-track-name="list-view"
         class="btn view-btn"
         (click)="updateListViewToggle(true)"
         [disabled]="isListView$()"
       >
         @if (!isListView$()) {
           <img
             src="../../../ui/assets/assets-{{ configuration$()?.tenantName }}/{{ configuration$()?.tenantName }}-list-view.svg"
             alt="list view icon"
           />
         }
         @if (isListView$()) {
           <img
             src="assets/icons/list-view-active.svg"
             alt="list view icon"
           />
         }
         <span>{{ convert('common.listView') }}</span>
       </button>
     </span>
   }
 </ng-template>

  @if (areSellCheckboxesEnabled || isSellUpdateInventoryFeatureEnabled || isSellReportingFeatureEnabled) {
    <app-action-list
      [selectedVehicles$]="sellVehiclesToggled$()"
      [selectedVehicleStatus$]="selectedVehicleStatus$()"
      [isSellReportingFeatureEnabled$]="isSellReportingFeatureEnabled"
      [isSellUpdateInventoryFeatureEnabled$]="isSellUpdateInventoryFeatureEnabled"
      [areMultipleTenantsSelected$]="areMultipleTenantsSelected"
      [isSingleSharedListSelected$]="isSingleOfferListSelected"
      [tenantUuid$]="tenantUuid"
      (onActionSelected)="showMultiActionModal($event)"
    ></app-action-list>
  }
</ng-container>
@defer {
  <app-shared-list-multi-action-modal [userType]="userType" (modalEvent)="completeOfferActions($event)"></app-shared-list-multi-action-modal>
}

